import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class BloodPool extends PhysicalThing {
	static key = "BloodPool";
	constructor(xy: XY) {
		super(xy, false);
	}

	getZOrder(): number {
		return ZOrder.CARPET_LIKE;
	}

	isVisible(): boolean {
		return true;
	}

	isHideUnderneath(): boolean {
		return false;
	}

	static deserialize(data: any): BloodPool {
		const b = new BloodPool(deserializeXY(data.xy));
		b.visualId = data.visualId;
		return b;
	}
}
